import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function passwordMatchValidator(passwordField: string, confirmPasswordField: string): ValidatorFn {
    return (from: AbstractControl): ValidationErrors | null => {
        const password = from.get(passwordField)?.value;
        const confirmPassword = from.get(confirmPasswordField)?.value;

        if (password && confirmPassword && password !== confirmPassword) {
            from.get(confirmPasswordField)?.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true }
        } else {
            return null;
        }
    }
}